var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tw-w-12 tw-h-12"},[_c('router-link',{attrs:{"to":("/profile/" + (_vm.data.profile.id))}},[_c('img',{staticClass:"tw-rounded-full",attrs:{"src":_vm.thumb}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }